/* eslint-disable indent */
import React, { useState } from "react";
import { Input, Select } from "antd";
import next from "../../../assests/images/master/next.png";
import down from "../../../assests/images/master/down.png";
import zone_location_Icon from "../../../assests/images/master/zone-location-icon.svg";
import local from "../../../assests/images/master/scooter.svg";
import within_state from "../../../assests/images/master/with_in_state.svg";
import metro from "../../../assests/images/master/city.svg";
import spcl_location from "../../../assests/images/master/spcl-location.svg";
import india from "../../../assests/images/master/india.svg";
import EllipsisWithTooltip from "../../EllipsisWithToolTip";
// import "./index.scss";
const RateCardTable = ({
  standardDocsSurfaceData,
  standardDocsAirData,
  standardNonDocsSurfaceData,
  standardNonDocsAirData,
  fastTrackSurfaceData,
  fastTrackAirData,
  fastTrackNonDoxAirData,
  fastTrackNonDoxSurfaceData,
  valuePlusDoxSurfaceData,
  valuePlusDoxAirData,
  valuePlusNonDoxSurfaceData,
  valuePlusNonDoxAirData,
  handleChangeDocs,
  templateType,
  handleDynamicSelect,
  extraZone,
  type,
}) => {
  const [showStandardDoxSurface, setShowStandardDoxSurface] = useState(true);
  const [showStandardDoxAir, setShowStandardDoxAir] = useState(false);
  const [showStandardNonDoxSurface, setShowStandardNonDoxSurface] =
    useState(false);
  const [showStandardNonDoxAir, setShowStandardNonDoxAir] = useState(false);

  const [showFastTrackSurface, setShowFastTrackSurface] = useState(false);
  const [showFastTrackAir, setShowFastTrackAir] = useState(false);
  const [showFastTrackNonDoxSurface, setShowFastTrackNonDoxSurface] =
    useState(false);
  const [showFastTrackNonDoxAir, setShowFastTrackNonDoxAir] = useState(false);

  const [showValuePlusDoxSurface, setShowValuePlusDoxSurface] = useState(false);
  const [showValuePlusDoxAir, setShowValuePlusDoxAir] = useState(false);
  const [showValuePlusNonDoxSurface, setShowValuePlusNonDoxSurface] =
    useState(false);
  const [showValuePlusNonDoxAir, setShowValuePlusNonDoxAir] = useState(false);
  const tableHeading = [
    { title: "Local", imgSrc: local },
    { title: "Within State", imgSrc: within_state },
    ...(type !== "viewCash"
      ? [
          { title: "My Zone 1", imgSrc: zone_location_Icon },
          { title: "My Zone 2", imgSrc: zone_location_Icon },
          { title: "My Zone 3", imgSrc: zone_location_Icon },
          { title: "My Zone 4", imgSrc: zone_location_Icon },
        ]
      : []),
    { title: "Metro", imgSrc: metro },
    { title: "Special location", imgSrc: spcl_location },
    { title: "Rest of India", imgSrc: india },
    ...extraZone,
  ];

  const tableSpan = tableHeading.length + 1;

  const handleDoxInput = (
    data,
    e,
    title,
    innerTitle,
    docType,
    parentIndex,
    childIndex
  ) => {
    let temp = data;
    //let outerIndex = temp.findIndex((item) => item.title == title);
    let { value } = e.target;
    const regex = /^\d{1,3}(\.\d{0,2})?$/;
    if (regex.test(value) || value === "") {
      temp[parentIndex].value[childIndex].value = value;
    }

    handleChangeDocs([...temp], docType);
  };

  const changeSelectBox = (e, data, title) => {
    let temp = data;
    temp.map((item) => {
      if (item.design) {
        item.title = e;
      }
    });
    handleDynamicSelect([...temp], title);
  };

  return (
    <div
      style={{
        maxWidth: "100%",
        overflowX: "auto",
        maxHeight: "530px",
        overflowY: "auto",
      }}
    >
      <table className={"rate-card-table"}>
        <thead>
          <tr>
            <th
              style={{ width: "15%", background: "#e9eaec" }}
              className="span-color-tbl"
            >
              Weight Slab
            </th>
            {tableHeading.map((e, index) => {
              return (
                <th key={e.title + "_" + index} style={{ width: "9%" }}>
                  <span className="align-center d-flex">
                    <img src={e.imgSrc} alt={e.title} />
                    <span style={{ paddingLeft: "4px" }}>
                      {" "}
                      <EllipsisWithTooltip text={e.title} maxLength={18} />
                    </span>
                  </span>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {/* ///--- STANDARD DOX Surface ---/// */}
          <tr
            onClick={() => setShowStandardDoxSurface(!showStandardDoxSurface)}
          >
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  standardDocsSurfaceData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showStandardDoxSurface ? down : next} alt="arrow" />{" "}
                Standard Dox (Surface)
              </span>
            </td>
          </tr>
          {standardDocsSurfaceData?.map((e, index) => {
            return (
              <tr
                key={e.title + "_stddxsurfface" + index}
                style={{ display: showStandardDoxSurface ? "revert" : "none" }}
                className="tr-animation"
              >
                <td className="f-13 text-left">
                  {e.design &&
                  (templateType === "create" || templateType === "edit") ? (
                    <Select
                      className="rate-card-select"
                      placeholder="Add 250 Gms"
                      defaultValue="Add 250 Gms"
                      options={[
                        {
                          value: "Add 250 Gms",
                          label: "Add 250 Gms",
                        },
                      ]}
                    />
                  ) : e?.design ? (
                    e?.title?.replace("Up to", "Additional")
                  ) : (
                    e?.title
                  )}
                </td>
                {e.value?.map((item, childIndex) => {
                  return (
                    <td
                      key={item + "_stddoxsur" + childIndex}
                      style={{ padding: "0 !important" }}
                      className={
                        item.pastVal && item.value !== item.pastVal
                          ? "high-light"
                          : ""
                      }
                    >
                      {templateType === "view" ||
                      templateType === "allocate" ? (
                        <span className="f-12">
                          <span
                            className={
                              item.pastVal && item.value !== item.pastVal
                                ? "high-light"
                                : ""
                            }
                          >
                            {item.value}
                          </span>
                          {item.pastVal && item.value !== item.pastVal && (
                            <span className="past-val">{item.pastVal}</span>
                          )}
                        </span>
                      ) : (
                        <Input
                          value={item?.value || "0.00"}
                          className="td-input"
                          onChange={(event) =>
                            handleDoxInput(
                              standardDocsSurfaceData,
                              event,
                              e.title,
                              item.title,
                              "standardDocsSurface",
                              index,
                              childIndex
                            )
                          }
                          min="0"
                        />
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
          {/* ///------/// */}
          {/* ///--- STANDARD DOX AIR ---/// */}
          <tr onClick={() => setShowStandardDoxAir(!showStandardDoxAir)}>
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  standardDocsAirData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showStandardDoxAir ? down : next} alt="arrow" />{" "}
                Standard Dox (Air)
              </span>
            </td>
          </tr>
          {standardDocsAirData?.map((e, index) => {
            return (
              <tr
                key={e.title + "_stddxair" + index}
                style={{ display: showStandardDoxAir ? "revert" : "none" }}
                className="tr-animation"
              >
                <td className="f-13 text-left">
                  {e.design &&
                  (templateType === "create" || templateType === "edit") ? (
                    <Select
                      className="rate-card-select"
                      placeholder="Add 250 Gms"
                      defaultValue="Add 250 Gms"
                      options={[
                        {
                          value: "Add 250 Gms",
                          label: "Add 250 Gms",
                        },
                      ]}
                    />
                  ) : e?.design ? (
                    e?.title?.replace("Up to", "Additional")
                  ) : (
                    e?.title
                  )}
                </td>
                {e.value.map((item, childIndex) => {
                  return (
                    <td
                      key={item + "_stddoxair" + childIndex}
                      style={{ padding: "0 !important" }}
                      className={
                        item.pastVal && item.value !== item.pastVal
                          ? "high-light"
                          : ""
                      }
                    >
                      {templateType === "view" ||
                      templateType === "allocate" ? (
                        <span className="f-12">
                          <span
                            className={
                              item.pastVal && item.value !== item.pastVal
                                ? "high-light"
                                : ""
                            }
                          >
                            {item.value}
                          </span>
                          {item.pastVal && item.value !== item.pastVal && (
                            <span className="past-val">{item.pastVal}</span>
                          )}
                        </span>
                      ) : (
                        <Input
                          value={item?.value || "0.00"}
                          className="td-input"
                          onChange={(event) =>
                            handleDoxInput(
                              standardDocsAirData,
                              event,
                              e.title,
                              item.title,
                              "standardDocsAir",
                              index,
                              childIndex
                            )
                          }
                          min="0"
                        />
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
          {/* ///------/// */}

          {/* ///--- STANDARD NON DOX SURFACE---/// */}
          <tr
            onClick={() =>
              setShowStandardNonDoxSurface(!showStandardNonDoxSurface)
            }
          >
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  standardNonDocsSurfaceData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img
                  src={showStandardNonDoxSurface ? down : next}
                  alt="arrow"
                />{" "}
                Standard Non-Dox (Surface)
              </span>
            </td>
          </tr>

          {showStandardNonDoxSurface &&
            standardNonDocsSurfaceData.map((e, index) => {
              return (
                <tr
                  key={e.title + "_stdndxsur" + index}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        onChange={(e) =>
                          changeSelectBox(
                            e,
                            standardNonDocsSurfaceData,
                            "standardNonDocs"
                          )
                        }
                        defaultValue={
                          e?.design
                            ? e?.title?.replace("Up to", "Additional")
                            : e?.title
                        }
                        options={[
                          {
                            value: "Add 500 Gms",
                            label: "Add 500 Gms",
                          },
                          {
                            value: "Add 1000 Gms",
                            label: "Add 1000 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "__stdndox_sur" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            min="0"
                            onChange={(event) =>
                              handleDoxInput(
                                standardNonDocsSurfaceData,
                                event,
                                e.title,
                                item.title,
                                "standardNonDocsSurface",
                                index,
                                childIndex
                              )
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}
          {/* ///--- STANDARD NON DOX AIR---/// */}
          <tr onClick={() => setShowStandardNonDoxAir(!showStandardNonDoxAir)}>
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  standardNonDocsAirData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showStandardNonDoxAir ? down : next} alt="arrow" />{" "}
                Standard Non-Dox (Air)
              </span>
            </td>
          </tr>

          {showStandardNonDoxAir &&
            standardNonDocsAirData.map((e, index) => {
              return (
                <tr
                  key={e.title + "_stdndxsur" + index}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        onChange={(e) =>
                          changeSelectBox(
                            e,
                            standardNonDocsAirData,
                            "standardNonDocs"
                          )
                        }
                        defaultValue={
                          e?.design
                            ? e?.title?.replace("Up to", "Additional")
                            : e?.title
                        }
                        options={[
                          {
                            value: "Add 500 Gms",
                            label: "Add 500 Gms",
                          },
                          {
                            value: "Add 1000 Gms",
                            label: "Add 1000 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "__stdndox_sur" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            min="0"
                            onChange={(event) =>
                              handleDoxInput(
                                standardNonDocsAirData,
                                event,
                                e.title,
                                item.title,
                                "standardNonDocsAir",
                                index,
                                childIndex
                              )
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}

          {/* ///--- Fast Track - Dox - Surface Mode ---/// */}
          <tr onClick={() => setShowFastTrackSurface(!showFastTrackSurface)}>
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  fastTrackSurfaceData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showFastTrackSurface ? down : next} alt="arrow" />{" "}
                Fast Track - Dox (Surface)
              </span>
            </td>
          </tr>
          {showFastTrackSurface &&
            fastTrackSurfaceData.map((e, index) => {
              return (
                <tr key={e.title + "_fst_sur" + index} className="tr-animation">
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        placeholder="Add 250 Gms"
                        defaultValue="Add 250 Gms"
                        options={[
                          {
                            value: "Add 250 Gms",
                            label: "Add 250 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value?.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "_fst_sur_dx" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            min="0"
                            onChange={(event) =>
                              handleDoxInput(
                                fastTrackSurfaceData,
                                event,
                                e.title,
                                item.title,
                                "fastTrackSurface",
                                index,
                                childIndex
                              )
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}
          {/* ///--- Fast Track - Dox - Air Mode ---/// */}
          <tr onClick={() => setShowFastTrackAir(!showFastTrackAir)}>
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  fastTrackAirData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showFastTrackAir ? down : next} alt="arrow" /> Fast
                Track - Dox (Air)
              </span>
            </td>
          </tr>
          {showFastTrackAir &&
            fastTrackAirData.map((e, index) => {
              return (
                <tr
                  key={e.title + "_fst_dx_air" + index}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        placeholder="Add 250 Gms"
                        defaultValue="Add 250 Gms"
                        options={[
                          {
                            value: "Add 250 Gms",
                            label: "Add 250 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value?.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "_fst_dox_air_" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            min="0"
                            onChange={(event) =>
                              handleDoxInput(
                                fastTrackAirData,
                                event,
                                e.title,
                                item.title,
                                "fastTrackAir",
                                index,
                                childIndex
                              )
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}
          {/* ///--- Fast Track - Non - Dox Surface ---/// */}
          <tr
            onClick={() =>
              setShowFastTrackNonDoxSurface(!showFastTrackNonDoxSurface)
            }
          >
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  fastTrackNonDoxSurfaceData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img
                  src={showFastTrackNonDoxSurface ? down : next}
                  alt="arrow"
                />{" "}
                Fast track Non-Dox (Surface)
              </span>
            </td>
          </tr>
          {showFastTrackNonDoxSurface &&
            fastTrackNonDoxSurfaceData.map((e, index) => {
              return (
                <tr
                  key={e.title + "_fst_ndxsur" + index}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        onChange={(e) =>
                          changeSelectBox(
                            e,
                            fastTrackNonDoxSurfaceData,
                            "fastTrackNonDox"
                          )
                        }
                        defaultValue={
                          e?.design
                            ? e?.title?.replace("Up to", "Additional")
                            : e?.title
                        }
                        options={[
                          {
                            value: "Add 500 Gms",
                            label: "Add 500 Gms",
                          },
                          {
                            value: "Add 1000 Gms",
                            label: "Add 1000 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value?.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "fst_ndx_sur" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            min="0"
                            onChange={(event) =>
                              handleDoxInput(
                                fastTrackNonDoxSurfaceData,
                                event,
                                e.title,
                                item.title,
                                "fastTrackNonDoxSurface",
                                index,
                                childIndex
                              )
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}
          {/* ///--- Fast Track - Non - Dox Air ---/// */}
          <tr
            onClick={() => setShowFastTrackNonDoxAir(!showFastTrackNonDoxAir)}
          >
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  fastTrackNonDoxAirData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showFastTrackNonDoxAir ? down : next} alt="arrow" />{" "}
                Fast track Non-Dox (Air)
              </span>
            </td>
          </tr>
          {showFastTrackNonDoxAir &&
            fastTrackNonDoxAirData.map((e, index) => {
              return (
                <tr
                  key={e.title + "_fst_ndxair" + index}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        onChange={(e) =>
                          changeSelectBox(
                            e,
                            fastTrackNonDoxAirData,
                            "fastTrackNonDox"
                          )
                        }
                        defaultValue={
                          e?.design
                            ? e?.title?.replace("Up to", "Additional")
                            : e?.title
                        }
                        options={[
                          {
                            value: "Add 500 Gms",
                            label: "Add 500 Gms",
                          },
                          {
                            value: "Add 1000 Gms",
                            label: "Add 1000 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "fst_ndx_air" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            min="0"
                            onChange={(event) =>
                              handleDoxInput(
                                fastTrackNonDoxAirData,
                                event,
                                e.title,
                                item.title,
                                "fastTrackNonDoxAir",
                                index,
                                childIndex
                              )
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}

          {/* ///--- Value Plus DOX Surface---/// */}
          <tr
            onClick={() => setShowValuePlusDoxSurface(!showValuePlusDoxSurface)}
          >
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  valuePlusDoxSurfaceData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showValuePlusDoxSurface ? down : next} alt="arrow" />{" "}
                Value Plus Dox (Surface)
              </span>
            </td>
          </tr>
          {showValuePlusDoxSurface &&
            valuePlusDoxSurfaceData.map((e, index) => {
              return (
                <tr
                  key={e.title + "val_doxsur" + index}
                  style={{
                    display: showValuePlusDoxSurface ? "revert" : "none",
                  }}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        placeholder="Add 250 Gms"
                        defaultValue="Add 250 Gms"
                        options={[
                          {
                            value: "Add 250 Gms",
                            label: "Add 250 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "_val_dx_sur" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            onChange={(event) =>
                              handleDoxInput(
                                valuePlusDoxSurfaceData,
                                event,
                                e.title,
                                item.title,
                                "valueplusDoxSurface",
                                index,
                                childIndex
                              )
                            }
                            min="0"
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}
          {/* ///--- Value Plus DOX Surface---/// */}
          <tr onClick={() => setShowValuePlusDoxAir(!showValuePlusDoxAir)}>
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  valuePlusDoxAirData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showValuePlusDoxAir ? down : next} alt="arrow" />{" "}
                Value Plus Dox (Air)
              </span>
            </td>
          </tr>
          {showValuePlusDoxAir &&
            valuePlusDoxAirData.map((e, index) => {
              return (
                <tr
                  key={e.title + "val_doxair" + index}
                  style={{ display: showValuePlusDoxAir ? "revert" : "none" }}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        placeholder="Add 250 Gms"
                        defaultValue="Add 250 Gms"
                        options={[
                          {
                            value: "Add 250 Gms",
                            label: "Add 250 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "_val_dx_air" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            onChange={(event) =>
                              handleDoxInput(
                                valuePlusDoxAirData,
                                event,
                                e.title,
                                item.title,
                                "valueplusDoxAir",
                                index,
                                childIndex
                              )
                            }
                            min="0"
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}

          {/* ///--- Vakue Plus NON DOX Surface---/// */}
          <tr
            onClick={() =>
              setShowValuePlusNonDoxSurface(!showValuePlusNonDoxSurface)
            }
          >
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  valuePlusNonDoxSurfaceData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img
                  src={showValuePlusNonDoxSurface ? down : next}
                  alt="arrow"
                />{" "}
                Value Plus Non-Dox (Surface)
              </span>
            </td>
          </tr>

          {showValuePlusNonDoxSurface &&
            valuePlusNonDoxSurfaceData.map((e, index) => {
              return (
                <tr
                  key={e.title + "val_ndx_sur" + index}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        onChange={(e) =>
                          changeSelectBox(
                            e,
                            valuePlusNonDoxSurfaceData,
                            "valueplusNonDox"
                          )
                        }
                        defaultValue={
                          e?.design
                            ? e?.title?.replace("Up to", "Additional")
                            : e?.title
                        }
                        options={[
                          {
                            value: "Add 500 Gms",
                            label: "Add 500 Gms",
                          },
                          {
                            value: "Add 1000 Gms",
                            label: "Add 1000 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value?.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "val_ndx_surface" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            min="0"
                            onChange={(event) =>
                              handleDoxInput(
                                valuePlusNonDoxSurfaceData,
                                event,
                                e.title,
                                item.title,
                                "valueplusNonDoxSurface",
                                index,
                                childIndex
                              )
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}
          {/* ///--- Vakue Plus NON DOX Air---/// */}
          <tr
            onClick={() => setShowValuePlusNonDoxAir(!showValuePlusNonDoxAir)}
          >
            <td colSpan={tableSpan} className="span-color-tbl tr-hover pointer">
              <span
                className={
                  valuePlusNonDoxAirData?.some((e) => e.oldPresent)
                    ? "high-light d-flex align-center"
                    : "d-flex align-center"
                }
              >
                <img src={showValuePlusNonDoxAir ? down : next} alt="arrow" />{" "}
                Value Plus Non-Dox (Air)
              </span>
            </td>
          </tr>

          {showValuePlusNonDoxAir &&
            valuePlusNonDoxAirData.map((e, index) => {
              return (
                <tr
                  key={e.title + "val_ndx_sur" + index}
                  className="tr-animation"
                >
                  <td className="f-13 text-left">
                    {e.design &&
                    (templateType === "create" || templateType === "edit") ? (
                      <Select
                        className="rate-card-select"
                        onChange={(e) =>
                          changeSelectBox(
                            e,
                            valuePlusNonDoxAirData,
                            "valueplusNonDox"
                          )
                        }
                        defaultValue={
                          e?.design
                            ? e?.title?.replace("Up to", "Additional")
                            : e?.title
                        }
                        options={[
                          {
                            value: "Add 500 Gms",
                            label: "Add 500 Gms",
                          },
                          {
                            value: "Add 1000 Gms",
                            label: "Add 1000 Gms",
                          },
                        ]}
                      />
                    ) : e?.design ? (
                      e?.title?.replace("Up to", "Additional")
                    ) : (
                      e?.title
                    )}
                  </td>
                  {e.value?.map((item, childIndex) => {
                    return (
                      <td
                        key={item + "val_ndx_Air" + childIndex}
                        style={{ padding: "0.5rem" }}
                        className={
                          item.pastVal && item.value !== item.pastVal
                            ? "high-light"
                            : ""
                        }
                      >
                        {templateType === "view" ||
                        templateType === "allocate" ? (
                          <span className="f-12">
                            <span
                              className={
                                item.pastVal && item.value !== item.pastVal
                                  ? "high-light"
                                  : ""
                              }
                            >
                              {item.value}
                            </span>
                            {item.pastVal && item.value !== item.pastVal && (
                              <span className="past-val">{item.pastVal}</span>
                            )}
                          </span>
                        ) : (
                          <Input
                            value={item?.value}
                            className="td-input"
                            min="0"
                            onChange={(event) =>
                              handleDoxInput(
                                valuePlusNonDoxAirData,
                                event,
                                e.title,
                                item.title,
                                "valueplusNonDoxAir",
                                index,
                                childIndex
                              )
                            }
                          />
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          {/* ///------/// */}
        </tbody>
      </table>
    </div>
  );
};
export default React.memo(RateCardTable);
